/*
 * Gourmet Easy marquee — keep the track wider than the screen.
 *
 * The strip is a CSS animation over a track rendered twice, translating
 * -50% so the second copy lands exactly where the first began. That is
 * seamless only while one copy is at least as wide as the container.
 *
 * With the shipped claims a copy measures ~857px, so on a 1440px screen the
 * animation ran out of content 583px early and left an empty black band --
 * looking as though the marquee had stopped generating text. The animation
 * was always running; there simply was not enough of it.
 *
 * This clones the claim set until each half of the track covers the
 * container, which keeps -50% exact at any width and for any number of
 * claims. Re-measured on resize.
 */
(() => {
  function fill(marquee) {
    const track = marquee.querySelector('.ge-marquee-track');
    if (!track) return;

    const sets = [...track.querySelectorAll('.ge-marquee__set')];
    if (!sets.length) return;

    // The first set is the original; everything after it is ours to rebuild.
    const master = sets[0];
    sets.slice(1).forEach((s) => s.remove());

    const setWidth = master.getBoundingClientRect().width;
    const containerWidth = marquee.getBoundingClientRect().width;
    if (!setWidth || !containerWidth) return;

    /*
     * Copies per half, so that half the track always spans the container.
     * The +1 covers the partial set at the point the loop restarts.
     */
    const perHalf = Math.max(1, Math.ceil(containerWidth / setWidth) + 1);
    const frag = document.createDocumentFragment();
    for (let i = 1; i < perHalf * 2; i += 1) {
      frag.appendChild(master.cloneNode(true));
    }
    track.appendChild(frag);

    /*
     * Adding copies would otherwise speed the strip up: the animation still
     * takes `duration` to travel -50%, but -50% is now several sets rather
     * than one. Scaling the duration by the number of sets per half keeps
     * the pixels-per-second the section was authored for.
     */
    const base =
      parseFloat(getComputedStyle(marquee).getPropertyValue('--ge-marquee-duration')) || 24;
    track.style.animationDuration = base * perHalf + 's';

    /*
     * Published for ge-reviews.js, so the review carousel can travel at the
     * same speed as the strip above it rather than at a guessed constant.
     */
    marquee.dataset.gePxPerSecond = (setWidth / base).toFixed(2);
  }

  function fillAll() {
    document.querySelectorAll('.ge-marquee').forEach(fill);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillAll);
  } else {
    fillAll();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fillAll, 200);
  });
})();
